import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { url } from "../requests/getAdvisor";
import patchAdvisor from "../requests/patchAdvisor";
export default function usePatchAdvisor(advisorId, config, options) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (body) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return await patchAdvisor(advisorId, body, config);
        },
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["advisor"],
            });
            queryClient.invalidateQueries({
                queryKey: ["advisor", advisorId],
            });
            queryClient.invalidateQueries({
                queryKey: [advisorId],
            });
            queryClient.invalidateQueries({
                queryKey: ["advisors"],
            });
            queryClient.invalidateQueries({
                queryKey: ["advisor", advisorId, url(advisorId)],
            });
            queryClient.invalidateQueries({
                queryKey: ["advisor-view-permissions"],
            });
            if (options?.onSuccess !== undefined) {
                options.onSuccess(data, variables, context);
            }
        },
    });
    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        isError: mutation.isError,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        data: mutation.data,
        reset: mutation.reset,
    };
}
//# sourceMappingURL=usePatchAdvisor.js.map